<template>
  <div>
    <!-- 报警管理查询表单 -->
    <el-form
    :model="search_form"
    label-width="100px"
    class="search_form"
    ref="search_form"
    >
      <el-form-item label="设备类型" prop="deviceType">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="search_form.deviceType"
        placeholder="请选择设备类型"
        clearable
        >
          <el-option
          label="冷链车"
          value="1"
          ></el-option>
          <el-option
          label="温度计"
          value="2"
          ></el-option>
          <el-option
          label="冷库"
          value="3"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备名称" prop="deviceKey">
        <el-input placeholder="请输入设备名称" v-model="search_form.deviceKey"></el-input>
      </el-form-item>
      <el-form-item label="点位类型" prop="deviceAtt">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="search_form.deviceAtt"
        placeholder="请选择点位类型"
        clearable
        >
          <el-option
          label="温度"
          value="1"
          ></el-option>
          <el-option
          label="湿度"
          value="2"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报警时间" prop="warn_date">
        <el-date-picker
        style="width: 100%;"
        v-model="search_form.warn_date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd"
        @change="warn_date_change"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="状态" prop="handleStatus">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="search_form.handleStatus"
        placeholder="请选择状态"
        clearable
        >
          <el-option
          label="未处理"
          value="0"
          ></el-option>
          <el-option
          label="已处理"
          value="1"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
        @click="search_alarm"
        type="primary"
        >查询</el-button>
        <el-button
        @click="reset_alarm"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 报警管理列表 -->
    <el-table
    v-loading="list_loading"
    highlight-current-row
    :data="alarm_data"
    max-height="500"
    ref="alarm_table"
    :row-key="getRowKeys"
    :expand-row-keys="expands"
    @expand-change="expandChange"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <!-- 报警管理明细表格 -->
          <el-table
          v-loading="detail_loading"
          highlight-current-row
          :data="alarm_detail_data"
          style="width: 800px;margin: 0 auto;"
          max-height="200"
          >
            <el-table-column
            label="报警时间"
            prop="startTime"
            align="center"></el-table-column>
            <el-table-column
            :label="scope.row.deviceAtt==1?'温度(°C)':'湿度(%)'"
            prop="pointValue"
            align="center"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
      label="设备类型"
      prop="deviceType"
      align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.deviceType==1">冷链车</span>
          <span v-else-if="scope.row.deviceType==2">温度计</span>
          <span v-else>冷库</span>
        </template>
      </el-table-column>
      <el-table-column
      label="设备名称"
      prop="deviceName"
      min-width="100"
      align="center"></el-table-column>
      <el-table-column
      label="设备编号"
      prop="deviceId"
      min-width="100"
      align="center"></el-table-column>
      <el-table-column
      label="点位类型"
      prop="deviceAtt"
      align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.deviceAtt==1">温度</span>
          <span v-else>湿度</span>
        </template>
      </el-table-column>
      <el-table-column
      label="报警时间"
      prop="warnTime"
      min-width="100"
      align="center"></el-table-column>
      <el-table-column
      label="报警数值"
      prop="warnData"
      align="center"></el-table-column>
      <el-table-column
      label="报警上限"
      prop="upLimit"
      align="center"></el-table-column>
      <el-table-column
      label="报警下限"
      prop="lowerLimit"
      align="center"></el-table-column>
      <el-table-column
      label="处理时间"
      prop="handleTime"
      align="center"
      min-width="150"></el-table-column>
      <el-table-column
      label="处理人"
      prop="handleBy"
      align="center"></el-table-column>
      <el-table-column
      label="处理状态"
      prop="handleStatus"
      align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.handleStatus==0">未处理</span>
          <span v-else>已处理</span>
        </template>
      </el-table-column>
      <el-table-column
      label="参照值"
      prop="traceId"
      min-width="100"
      align="center"></el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      align="center"
      min-width="120">
        <template slot-scope="scope">
          <el-tag
          class="operate"
          effect="dark"
          @click="check_list(scope.row)"
          >查看</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          @click="handle_list(scope.row)"
          v-if="btn_permission.includes('middle:warnRecord:handle')&&scope.row.handleStatus==0
          ||btn_permission.includes('superAdmin')&&scope.row.handleStatus==0"
          >处理</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          type="success"
          @click="handle_details(scope.row)"
          v-if="btn_permission.includes('middle:warnRecord:handleDetail')&&scope.row.handleStatus==1
          ||btn_permission.includes('superAdmin')&&scope.row.handleStatus==1"
          >详情</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 报警管理列表分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="alarm_size_change"
    @current-change="alarm_current_change"
    :current-page="pageparm.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparm.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparm.total"
    ></el-pagination>
    <!-- 报警处理弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="handle_show"
    title="处理报警"
    v-dialogDrag
    >
      <el-form
      :model="handle_form"
      ref="handle_form"
      class="handle_warn_form"
      label-width="100px"
      :rules="handle_rules"
      >
        <el-form-item label="处理措施" prop="measure">
          <el-cascader
          v-model="handle_form.measure"
          :options="measure_list"
          style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注" prop="notes">
          <el-input
          type="textarea"
          placeholder="备注"
          v-model="handle_form.notes"
          style="width: 100%;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit_return" type="primary">确定</el-button>
          <el-button @click="reset_return">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 处理结果弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="result_show"
    title="报警处理结果"
    v-dialogDrag
    >
      <el-timeline style="padding: 10px;">
        <el-timeline-item
        :timestamp="result_obj.handleTime"
        placement="top"
        >
          <el-card>
            <div>「{{result_obj.handleBy}}」已处理报警，处理措施：{{result_obj.handleMeasuresText}}
            <span v-if="result_obj.handleNote!=''">，处理备注：{{result_obj.handleNote}}</span></div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //报警管理查询表单
        search_form:{
          deviceType:'',
          deviceKey:'',
          deviceAtt:'',
          warn_date:'',
          startDate:'',
          endDate:'',
          handleStatus:''
        },
        //报警管理列表
        alarm_data:[],
        //报警管理列表懒加载
        list_loading:false,
        //报警管理列表分页
        pageparm:{
          currentPage:1,
          pageSize:10,
          total:1
        },
        //当前行数据
        now_alarm_row:{},
        //报警处理弹框
        handle_show:false,
        handle_form:{
          measure:'',
          notes:''
        },
        handle_rules:{
          measure:[
            {required:true,message:'请选择处理措施',trigger:'change'}
          ]
        },
        measure_list:[],
        //处理结果弹框
        result_show:false,
        result_obj:{},
        //报警管理列表展开行
        expands:[],
        //展开行懒加载
        detail_loading:false,
        //展开行数据列表
        alarm_detail_data:[]
      }
    },
    created() {
      this.$nextTick(()=>{
        this.search_form.warn_date=[this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd'),this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd')]
        //报警时间change事件
        this.warn_date_change(this.search_form.warn_date)
        //获取报警管理列表
        this.get_alarm()
      })
    },
    mounted() {

    },
    methods:{
      //获取处理措施下拉列表
      get_measure_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/dict/formSelect/tree/deviceWarnSelect',
        }).then(data=>{
          if(data.data.success==true){
            that.measure_list=data.data.data
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //获取报警管理列表
      get_alarm(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warnRecord/list',
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            deviceType:that.search_form.deviceType,
            deviceKey:that.search_form.deviceKey,
            deviceAtt:that.search_form.deviceAtt,
            startDate:that.search_form.startDate,
            endDate:that.search_form.endDate,
            handleStatus:that.search_form.handleStatus
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.alarm_data=data.data.data.list
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //报警时间change事件
      warn_date_change(value){
        if(value!=null){
          this.search_form.startDate=value[0]
          this.search_form.endDate=value[1]
        }else{
          this.search_form.startDate=''
          this.search_form.endDate=''
        }
      },
      //报警管理列表分页
      alarm_size_change(val){
        this.pageparm.pageSize=val
        //获取报警管理列表
        this.get_alarm()
      },
      alarm_current_change(val){
        this.pageparm.currentPage=val
        //获取报警管理列表
        this.get_alarm()
      },
      //查询报警管理列表
      search_alarm(){
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //获取报警管理列表
        this.get_alarm()
      },
      //重置报警管理列表
      reset_alarm(){
        this.search_form.startDate=''
        this.search_form.endDate=''
        this.$refs['search_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //获取报警管理列表
        this.get_alarm()
      },
      //查看报警详情
      check_list(row){
        if(row.deviceType==3){//冷库
          this.router_fn(row,'/cold/cold_storage_data','冷库数据查询')
        }else{//冷链车、温度计
          this.router_fn(row,'/cold/manage','冷链管理')
        }
      },
      //路由跳转公共函数
      router_fn(row,path,path_name){
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes(path)==false){
          this.$store.commit('add_tabs',{
            route:path,
            name:path_name
          })
        }
        this.$store.commit('set_active_index',path)
        this.$router.push({
          path:path,
          query:{
            row:row
          }
        })
      },
      //处理报警
      handle_list(row){
        this.now_alarm_row=row
        this.handle_show=true
        this.handle_form.measure=''
        this.handle_form.notes=''
        //获取处理措施下拉列表
        this.get_measure_list()
      },
      //查询报警处理结果
      handle_details(row){
        this.result_show=true
        //查询报警处理结果
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warnRecord/handle/detail/'+row.id
        }).then(data=>{
          if(data.data.success==true){
            that.result_obj=data.data.data
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //处理报警提交
      submit_return(){
        let that=this
        that.$refs.handle_form.validate((valid)=>{
          if(valid){
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/middle/warnRecord/handle/'+that.now_alarm_row.id,
              headers:{
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "content-type":"application/json;charset=UTF-8"
              },
              data:{
                handleNote:that.handle_form.notes,
                handleMeasures:that.handle_form.measure[1]
              }
            }).then(data=>{
              if(data.data.success==true){
                that.handle_show=false
                that.$message.success(data.data.message)
                //获取报警管理列表
                that.get_alarm()
              }else{
                that.$message.warning(data.data.message)
              }
            })
          }else{
            return false
          }
        })
      },
      //处理报警重置
      reset_return(){
        this.handle_form.measure=''
        this.handle_form.notes=''
        this.$refs['handle_form'].resetFields()
      },
      //报警管理列表展开行相关事件
      getRowKeys(row){
        return row.id
      },
      //实现只有一个展开折叠
      expandChange(row,expandedRows){
        this.$refs.alarm_table.setCurrentRow(row)
        if(expandedRows.length){
          this.expands=[]
          if(row){
            //要展开的某行
            this.expands.push(row.id)
          }
        }else{
          //初始不展开
          this.expands=[]
        }
        let that=this
        that.detail_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warnRecord/detailList',
          params:{
            deviceType:row.deviceType,
            startDate:row.warnTime+' 00:00:00',
            endDate:row.warnTime+' 23:59:59',
            deviceId:row.deviceId,
            upLimit:row.upLimit,
            lowerLimit:row.lowerLimit,
            traceId:row.traceId
          }
        }).then(data=>{
          that.detail_loading=false
          if(data.data.success==true){
            that.alarm_detail_data=data.data.data
          }else{
            that.$message.error(data.data.message)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .search_form{
    .el-form-item{
      display: inline-block;
      width: 49%;
    }
    @media screen and (max-width:720px) {
      .el-form-item{
        width: 100%;
      }
    }
  }
  .handle_warn_form{
    .el-textarea{
      width: auto;
    }
    .el-form-item{
      width: 100%;
    }
  }
  .operate{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/alarm_manage.vue